// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","dark":"_2KKx","zRed":"rgb(237, 85, 100)","card":"QSty","title":"wjQ6","red":"_1Cfs","hideOverflow":"_2xrC","image":"_2RJe","button":"_3Udu","overlay":"_1jn1"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Cards/InfoCard/InfoCard.scss
// module id = 6eii
// module chunks = 0